'use client';

import { CSSProperties } from 'react';

import { Stack, Typography } from '@mui/material';

import colors from '@/styles/themes/colors';
import { IndustryColor, IndustryData } from '@/types/industry.type';

import styles from './IndustryCard.module.scss';

const colorMap: Record<IndustryColor, string> = {
  blue: colors.blue500,
  pink: colors.pink500,
  green: colors.green500,
  orange: colors.orange500,
};

const bgColorMap: Record<IndustryColor, string> = {
  blue: colors.blue950,
  pink: colors.pink950,
  green: colors.green950,
  orange: colors.orange950,
};

interface IndustryCardProps {
  industry: IndustryData;
}

const IndustryCard = ({ industry }: IndustryCardProps) => {
  const Icon = industry.icon;
  const accentColor = colorMap[industry.color];
  const bgColor = bgColorMap[industry.color];
  const style = { '--accent-color': bgColor } as CSSProperties;

  return (
    <Stack alignItems="center" justifyContent="center" className={styles.card} style={style}>
      <Stack
        position="relative"
        zIndex={2}
        alignItems="center"
        justifyContent="center"
        minWidth={{ xs: 48, md: 64 }}
        minHeight={{ xs: 48, md: 64 }}
        padding={{ xs: 2.5, md: 3.75 }}
        mb={{ xs: 3, md: 6 }}
        borderRadius="24px"
        color={accentColor}
        className={styles.iconContainer}
        sx={{
          background: bgColor,
          boxShadow: `0 3px 54px 0 ${accentColor}26`,
        }}
      >
        {Icon && <Icon size={48} />}
      </Stack>
      <Typography
        component="h3"
        sx={{
          typography: { xs: 'subtitle1', md: 'h5' },
        }}
        fontWeight={400}
        textAlign="center"
        color={accentColor}
      >
        {industry.title}
      </Typography>
    </Stack>
  );
};

export default IndustryCard;
